import { useContext, useEffect } from 'react';
import { Anchor, Box, Heading, Icon, Paragraph } from '@zillow/constellation-10';
import { IconRateUnhappyFilled } from '@zillow/constellation-icons';
import { useIdVerificationCallbacks, useTermSet } from '../../../IdvContext';
import { ExitReason, TermSet } from '../../../../../models';
import { CUSTOMER_SUPPORT_LINK, EXPERIAN_DISPUTE_URL } from '../../../constants/urls';
import { WizardContext } from '../../../wizard/WizardContext';

function LandlordContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Your account is temporarily locked
      </Heading>
      <Paragraph>
        For security, your account has been temporarily locked after three failed attempts to verify your identity.
        Please wait 24 hours before submitting again.
      </Paragraph>
      <Paragraph>
        During this time, you won’t be able to access applicant’s information, including credit and background reports.
      </Paragraph>
      <Paragraph>
        Accounts cannot be unlocked manually during the 24-hour waiting period. If you continue to experience issues
        with verifying your identity, please{' '}
        <Anchor href={CUSTOMER_SUPPORT_LINK} target="_blank" rel="noopener noreferrer">
          contact customer support
        </Anchor>
        .
      </Paragraph>
    </Box>
  );
}

function RenterContent() {
  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
      <Icon size="lg" css={{ color: 'icon.subtle' }}>
        <IconRateUnhappyFilled />
      </Icon>
      <Heading level={2} textStyle="heading-sm">
        Your account is temporarily locked
      </Heading>
      <Paragraph>
        For security, your account has been temporarily locked after three failed attempts to verify your identity.
        Please wait 24 hours before submitting again.
      </Paragraph>
      <Paragraph>During this time, you won’t be able to access the credit and background report services.</Paragraph>
      <Paragraph>
        Accounts cannot be unlocked manually during the 24-hour waiting period. If you continue to experience issues
        with verifying your identity, please{' '}
        <Anchor href={EXPERIAN_DISPUTE_URL} target="_blank" rel="noopener noreferrer">
          contact Experian
        </Anchor>
        .
      </Paragraph>
    </Box>
  );
}

export default function ErrorUserLockedOutStep() {
  const { setOnNext } = useContext(WizardContext);
  const { onExit } = useIdVerificationCallbacks();
  const termSet = useTermSet();

  useEffect(() => {
    setOnNext(() => async () => onExit({ reason: ExitReason.UserLockedOut, success: false }));
    return () => setOnNext(null);
  }, [onExit, setOnNext]);

  return termSet === TermSet.LandlordScreening ? <LandlordContent /> : <RenterContent />;
}
